export const ITEMS_PER_PAGE = 9;
export const TRIM_CHARACTER_LIMIT = 110;
